import _ from 'lodash';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import { styleVars } from 'gooey';

export interface GlowProps {
  /**
   * The custom class name to apply to the glow.
   * @default ''
   */
  className?: string;
  /**
   * The color of the glow.
   * @default 'black'
   */
  color?: 'black' | 'white' | 'primary' | 'secondary' | 'accent';
  /**
   * The height of the glow.
   * @default 50
   */
  height?: string | number;
  /**
   * The width of the glow.
   */
  width?: string | number;
  /**
   * The amount of blur to apply to the glow.
   * @default 50
   */
  blur?: number;
}

export function Glow({
  height = 50,
  width,
  blur = 50,
  color = 'black',
  className = '',
}: GlowProps) {
  const colorClassname = React.useMemo(() => {
    switch (color) {
      case 'primary':
        return 'bg-primary';
      case 'secondary':
        return 'bg-secondary';
      case 'accent':
        return 'bg-accent';
      case 'white':
        return 'bg-[#fff]';
      default:
        return 'bg-[#202229]';
    }
  }, [color]);
  return (
    <div
      className={twMerge(
        'absolute flex-none rounded-full blur-(--glow-blur)',
        colorClassname,
        width && 'w-(--glow-width)',
        height && 'h-(--glow-height)',
        className
      )}
      style={styleVars({
        '--glow-height': `${height}px`,
        '--glow-width': `${width ?? 0}px`,
        '--glow-blur': `${blur}px`,
      })}
    />
  );
}
